import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter, checkVideoEnabled } from '../../utils/HelperFunctions';
import deviceManager from '../../utils/DeviceManager';
import fanoutClient from '../../utils/FanoutClient';
import { v1 as uuidv1 } from 'uuid';
import * as chatActions from "../../reducers/chat";
import * as roomActions from "../../reducers/room";
import * as devicesActions from "../../reducers/device";
import Conference from "./Conference";
import Loader from "../Widget/Loader";

class Room extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role: null,
            linkId: null,
            isError: false,
            isLoading: false,
            loadingMessage: '',
            knockGranted: false,
            show: false,
            username: null,
            userPhoto: null,
            name: null,
            userId: null,
            errorMessage: null,
            registerOverlay: false,
            errorWhere: null,
            errorTitle: null,
            errorMessage: null
        }

        this.sessionId = uuidv1();
        this.handleRoomClosed = this.handleRoomClosed.bind(this);
        this.handleRoomStopped = this.handleRoomStopped.bind(this);
        this.handleFanoutReqestExpired = this.handleFanoutReqestExpired.bind(this);
        this.getCallState = this.getCallState.bind(this);
        this.handleKnockGranted = this.handleKnockGranted.bind(this);
        this.handleKnockRevoked = this.handleKnockRevoked.bind(this);
        this.handleExit = this.handleExit.bind(this);

        // TODO change this after to get rid of hardcoding and instead request ip from server);
        fanoutClient.on('roomClosed', this.handleRoomClosed);
        fanoutClient.on('roomStopped', this.handleRoomStopped);
        fanoutClient.on('fanoutReqestExpired', this.handleFanoutReqestExpired);
    }


    getCallState() {
        return {};
    }

    async componentDidMount() {
        console.log('Room componentDidMount', this.props)
        const { role } = this.props;

        if (role && role === 'audience') {
            fanoutClient.on('knockGranted', this.handleKnockGranted);
            fanoutClient.on('knockRevoked', this.handleKnockRevoked);
        }

        if (checkVideoEnabled) {
            checkVideoEnabled();
        }
    }

    componentDidUpdate(prevProps) {
        const { user, userLoaded, role } = this.props;
        console.log('Room has been updated', user, userLoaded, role)

        if (prevProps.role !== role && role === 'audience') {

            if (prevProps.role && prevProps.role === 'audience') {
                fanoutClient.removeListener('knockGranted', this.handleKnockGranted);
                fanoutClient.removeListener('knockRevoked', this.handleKnockRevoked);
            }
            if (role && role === 'audience') {
                fanoutClient.on('knockGranted', this.handleKnockGranted);
                fanoutClient.on('knockRevoked', this.handleKnockRevoked);
            }
        }
    }

    componentWillUnmount() {
        const { role } = this.props;

        fanoutClient.removeListener('roomClosed', this.handleRoomClosed);
        fanoutClient.removeListener('roomStopped', this.handleRoomStopped);
        fanoutClient.removeListener('fanoutReqestExpired', this.handleFanoutReqestExpired);

        if (role && role === 'audience') {
            fanoutClient.removeListener('knockGranted', this.handleKnockGranted);
            fanoutClient.removeListener('knockRevoked', this.handleKnockRevoked);
        }

        // fanoutClient.disconnectFromFanout(this.getCallState());

        if (this.exitTimeout) {
            clearTimeout(this.exitTimeout);
        }
        if (this.messageTimeout) {
            clearTimeout(this.messageTimeout);
        }
        if (this.revokeTimeout) {
            clearTimeout(this.revokeTimeout);
        }
        if (this.grantedTimeout) {
            clearTimeout(this.grantedTimeout);
        }
    }

    handleKnockRevoked(data) {
        const { knockGranted } = this.state;
        const { role } = this.props;

        if (role === 'presenter' || role === 'moderator' || role === 'guest_speaker')
            return;

        try {
            console.log("handleKnockRevoked response received from server", data);
            if (knockGranted) {
                this.setState({
                    isLoading: true,
                    loadingMessage: 'Moving to audience'
                });
                this.revokeTimeout = setTimeout(() => {
                    this.setState({
                        knockGranted: false,
                        token: null,
                        isLoading: false,
                        loadingMessage: ''
                    });
                }, 2000);
            } else {
                this.setState({
                    knockGranted: false,
                    token: null
                });
            }
        }
        catch (error) {
            console.error("Failed handleKnockRevoked", error, data);
        }
    }

    handleKnockGranted(data) {
        const { role } = this.props;
        if (role === 'presenter' || role === 'moderator' || role === 'guest_speaker')
            return;

        try {
            console.log("handleKnockGranted response received from server", data);
            this.setState({
                isLoading: true,
                loadingMessage: 'Moving into live stream'
            });
            this.grantedTimeout = setTimeout(() => {
                this.setState({
                    knockGranted: true,
                    token: (data && data.payload ? data.payload.token : null),
                    isLoading: false,
                    loadingMessage: ''
                }, () => {
                    const { setPreConfiguration } = this.props;

                    if (setPreConfiguration) {
                        setPreConfiguration(true);
                    }
                });
            }, 2000);
        }
        catch (error) {
            console.error("Failed handleKnockGranted", error, data);
        }
    }

    handleRoomClosed(data) {
        const { displayMessage, hideMessage, role } = this.props;

        try {
            console.log("handleRoomClosed response received from server", data);
            if (displayMessage && hideMessage && role && role !== 'presenter') {
                hideMessage();
                this.messageTimeout = setTimeout(() => {
                    displayMessage('event_over', 2000);
                }, 500);
                this.exitTimeout = setTimeout(() => {
                    this.handleExit(true);
                }, 3000);
            } else {
                this.handleExit();
            }
        }
        catch (error) {
            console.error("Failed handleRoomClosed", error, data);
        }
    }

    handleRoomStopped(data) {
        const { displayMessage, hideMessage, role } = this.props;

        try {
            console.log("handleRoomStopped response received from server", data);
            if (displayMessage && hideMessage && role && role !== 'presenter') {
                hideMessage();
                this.messageTimeout = setTimeout(() => {
                    displayMessage('event_over', 4000);
                }, 595000);
                this.exitTimeout = setTimeout(() => {
                    this.handleExit(true);
                }, 600000);
            } else {
                this.handleExit();
            }
        }
        catch (error) {
            console.error("Failed handleRoomStopped", error, data);
        }
    }

    handleFanoutReqestExpired(data) {
        const { t } = this.props;

        try {
            console.log("handleFanoutReqestExpired response received from server", data);
            if (data && data.message) {
                this.setState({
                    isError: true,
                    errorWhere: data.where || '',
                    errorTitle: data.title || '',
                    errorMessage: t(data.message)
                });
            }
        }
        catch (error) {
            console.error("Failed handleFanoutReqestExpired", error, data);
        }
    }

    async handleExit(params) {
        const { handleExit } = this.props;

        await deviceManager.leaveConference();

        fanoutClient.cleanTheRoom();

        if (handleExit)
            handleExit(params);
    }

    renderError(errorMessage) {
        const { t } = this.props;

        return (
            <div className='error-wrapper'>
                <div className='error-div'>
                    <p className='error-title'>{t('network_problem')}</p>
                    <p className='error-message'>
                        {errorMessage ? errorMessage : null}
                        {errorMessage ? <br /> : null}
                        {t('np_text')}
                    </p>
                    <button
                        className='btn-reload'
                        onClick={() => window.location.reload()}
                    >
                        {t('reload')}
                    </button>
                </div>
            </div>
        );
    }


    render() {
        const { knockGranted, token, isError, errorCode, isLoading, loadingMessage } = this.state;
        const { role, user, eventItem, userPhoto, eventId, username, name, uid, joinUser } = this.props;
        console.log('Room render', user, role, eventItem, eventId);

        return (
            <Fragment>
                {(isError) ?
                    this.renderError(errorCode)
                    : isLoading ?
                        <Loader
                            text={loadingMessage}
                            dots={loadingMessage ? true : false}
                            type="page"
                        /> :
                        (role) ?
                            <Conference
                                token={token}
                                name={(name ? name : null)}
                                uid={uid ? uid : null}
                                isOwner={user ? user.isOwner : false}
                                isAdmin={(role && ((role === 'presenter') || (role === 'moderator')))}
                                username={username ? username : (name ? name : '')}
                                role={role}
                                preConfig={true}
                                email={this.props.user ? this.props.user.email : null}
                                userPhoto={userPhoto}
                                eventId={eventId}
                                eventItem={eventItem}
                                handleExit={this.handleExit}
                                knockGranted={knockGranted}
                                isListener={!role || (role && role === 'audience' && !knockGranted)}
                                joinUser={joinUser}
                            />
                            : <div />
                }

            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearMessages: () => {
            dispatch(chatActions.clearMessages({ messages: [] }));
        },
        displayMessage: (message, timer) => {
            dispatch(roomActions.displayMessage({ message: message, timer: timer }));
        },
        hideMessage: () => {
            dispatch(roomActions.hideMessage());
        },
        setPreConfiguration: (value) => {
            dispatch(devicesActions.setDevicesData({ preConfiguration: value }));
        }
    };
};

const RoomContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Room);

export default withTranslation()(withRouter(RoomContainer));